import { State } from 'common/store/reducers';

export const selectPublisherBrandCommissions = (state: State) => state.publisherBrandCommissions.data;

export const selectPublisherBrandCommissionsLoading = (state: State) => state.publisherBrandCommissions.loading;

export const selectPublisherBrandCommissionsError = (state: State) => state.publisherBrandCommissions.error;
